export enum CompanyExemptTypeEnum {
  ExemptAudit = 'EXEMPT_AUDIT_REQUIREMENT',
  ExemptPrivateCompany = 'EXEMPT_PRIVATE_COMPANY',
  ExemptedFromAuditRequirement = 'EXEMPTED_FROM_AUDIT_REQUIREMENT',
}
